import { Box, Flex, Text } from "@chakra-ui/react";

export default function AlternativePaymentDivider() {
  return (
    <Flex align="center" my="16px">
      <Box flex="1" h="1px" bg="#E6ECF3" />
      <Text minW="140px" color="#0B0E10" p="0 12px" fontSize="13px" fontWeight="400">
        or pay another way
      </Text>
      <Box flex="1" h="1px" bg="#E6ECF3" />
    </Flex>
  );
}
